import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "./layout/AdminLayout";
import Dashboard from "./pages/Dashboard";

import SliderList from "./pages/SliderList";
import SliderCreate from "./pages/SliderCreate";
import SliderEdit from "./pages/SliderEdit";

import NewsList from "./pages/NewsList";
import NewsCreate from "./pages/NewsCreate";
import NewsEdit from "./pages/NewsEdit";

import AboutTextEdit from "./pages/AboutTextEdit";

import ProductsList from "./pages/ProductsList";
import ProductCreate from "./pages/ProductCreate";
import ProductEdit from "./pages/ProductEdit";

import OrdersList from "./pages/OrdersList";

import ContactList from "./pages/ContactList";
import ContactDetail from "./pages/ContactDetail";

// auth pages
import Login from "./pages/Login";
import Forbidden from "./pages/Forbidden";
import { AuthProvider } from "./auth/AuthContext";
import RequireAuth from "./auth/RequireAuth";

// superadmin pages
import UsersList from "./pages/users/UsersList";
import UserCreate from "./pages/users/UserCreate";
import UserEdit from "./pages/users/UserEdit";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/forbidden" element={<Forbidden />} />

          {/* Private (login tələb edir) */}
          <Route element={<RequireAuth />}>
            <Route element={<AdminLayout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              {/* hamı görə bilər */}
              <Route path="/dashboard" element={<Dashboard />} />

              {/* ✅ user + admin + superadmin görə bilər (Slider) */}
              <Route element={<RequireAuth roles={["user", "admin", "superadmin"]} />}>
                <Route path="/sliders" element={<SliderList />} />
                <Route path="/sliders/new" element={<SliderCreate />} />
                <Route path="/sliders/:id/edit" element={<SliderEdit />} />
              </Route>

              {/* ✅ yalnız admin + superadmin */}
              <Route element={<RequireAuth roles={["admin", "superadmin"]} />}>
                <Route path="/news" element={<NewsList />} />
                <Route path="/news/new" element={<NewsCreate />} />
                <Route path="/news/:id/edit" element={<NewsEdit />} />

                <Route path="/products" element={<ProductsList />} />
                <Route path="/products/new" element={<ProductCreate />} />
                <Route path="/products/:id/edit" element={<ProductEdit />} />

                <Route path="/orders" element={<OrdersList />} />
                <Route path="/about-text" element={<AboutTextEdit />} />

                <Route path="/contacts" element={<ContactList />} />
                <Route path="/contacts/:id" element={<ContactDetail />} />
              </Route>

              {/* ✅ yalnız superadmin */}
              <Route element={<RequireAuth roles={["superadmin"]} />}>
                <Route path="/users" element={<UsersList />} />
                <Route path="/users/new" element={<UserCreate />} />
                <Route path="/users/:id" element={<UserEdit />} />
              </Route>
            </Route>
          </Route>

          {/* fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
